// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".conversationsHeader__conversationsHeader___3nViL{background-color:var(--header-background-color);height:195px;flex-shrink:0;overflow:hidden;width:100%;border-bottom:.5px solid #e9eff5}.conversationsHeader__content___1ip5W{padding:0 35px;display:flex;flex-direction:column;align-items:center;text-align:center}.conversationsHeader__chatIconWrapper___sswBE{margin-top:25px;border-radius:50%}.conversationsHeader__teamName___1pOnv{font-size:16px;font-weight:500;text-transform:capitalize;margin:10px 0 5px;color:var(--header-font-primary-color)}.conversationsHeader__greeting___A_wNb,.conversationsHeader__waitMessage___3YMpn{line-height:1.3;margin-top:5px;color:var(--header-font-secondary-color);width:100%}", ""]);
// Exports
exports.locals = {
	"white": "#fff",
	"primary": "#222",
	"secondary": "#717070",
	"primaryBlue": "#336dec",
	"primaryDarkerBlue": "#005bcc",
	"chatIconFrameWidth": "70px",
	"chatIconFrameHeight": "70px",
	"widgetFrameWidth": "400px",
	"widgetFrameHeight": "650px",
	"mobileScreenWidth": "550px",
	"mobileScreenHeight": "550px",
	"conversationsHeader": "conversationsHeader__conversationsHeader___3nViL",
	"content": "conversationsHeader__content___1ip5W",
	"chatIconWrapper": "conversationsHeader__chatIconWrapper___sswBE",
	"teamName": "conversationsHeader__teamName___1pOnv",
	"greeting": "conversationsHeader__greeting___A_wNb",
	"waitMessage": "conversationsHeader__waitMessage___3YMpn"
};
module.exports = exports;
